export function GuideController(
   guideData,
   introController,
   stepController,
   fullScreenController,
   conclusionController
) {
   let container = $('#guideContainer');

   container.on('click', '.js-fullscreen', event => {
      fullScreenController.toggle();
   });

   guideData.get().then(guide => {
      container.append(introController.getElementImmediately(guide, /* isSingle */ false));
      guide.steps.forEach((step, n) => {
         step.url = guide.url;
         container.append(stepController.getElement(step, /* isSingle */ false));
      });
      if (guide.type !== 'teardown' && guide.conclusion_rendered) {
         container.append(conclusionController.getElement(guide));
      }
   });
}
